import { ICommit } from "@/shared-models/ICommit";
import CoreAppOnboardingTypes from "@/apps/core-app-onboarding/store/types";
import { ICoreAppOnboardingState } from "@/apps/core-app-onboarding/types/ICoreAppOnboardingState";

/**
 * ACTIONS
 */
const actions = {
  initState: ({ commit }: ICommit, state: ICoreAppOnboardingState): void => {
    commit(CoreAppOnboardingTypes.INIT_STATE, state);
  },
};

export enum ActionKeys {}

export default actions;
